<template>
    <Main>
        <div slot="main" class="main">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png"
                        alt=""><span>返回</span></div>
            </div>
            <div class="content financial">
                <div class="top">
                    <div class="left">
                        <div class="title_data">

                            <span class="shadow">金融监管地域分布<img style="margin-left:0.36rem" src="../../assets/hhr_right.png"
                                    alt="" /></span>
                            <!-- 实验 -->
                            <!-- <el-button @click.stop="getNetworkModel">点我试试</el-button> -->
                            <div class="tab_box">
                                <div class="tab_item" :class="{ active: financialServiceStatus === '进行中' }"
                                    @click="financialService('进行中')">进行中
                                </div>
                                <div class="tab_item" :class="{ active: financialServiceStatus === '全部' }"
                                    @click="financialService('全部')">全部
                                </div>
                            </div>
                        </div>
                        <div class="total_data">
                            <div class="total_data_item">
                                <!-- <img src="../../assets/data_icon_001.png" alt=""> -->
                                <div style="width: 3rem;">
                                    <label>监管笔数(笔)</label>
                                    <!-- <span>{{ financialSupervisionDis.supervisionTotalCount }}</span> -->
                                    <dv-digital-flop :config="config2"
                                        style="min-width:1rem;height:0.6rem;margin-left:-0.05rem;margin-top:0.2rem" />
                                </div>
                            </div>
                            <div class="total_data_item total_data_item_1">
                                <!-- <img src="../../assets/data_icon_001.png" alt=""> -->
                                <div>
                                    <label>累计监管金额{{ headDate != '/nmzlqlogin' ? '(亿)' : '(万元)' }}</label>
                                    <!-- <span>{{ financialSupervisionDis.totalMoney }}</span> -->
                                    <dv-digital-flop :config="config3"
                                        style="min-width:3rem;height:0.6rem;margin-left:-0.05rem;margin-top:0.2rem" />
                                </div>
                            </div>
                        </div>
                        <div id="mapMain" v-if="isShowMap" class="map_main"></div>
                    </div>
                    <div class="right">
                        <!-- <div class="right_1">
                            <div class="title_data">
                                <span class="shadow">监管增长趋势<img style="margin-left:0.36rem"
                                        src="../../assets/hhr_right.png" alt="" /></span>
                            </div>
                            <div id="growthChart" style="" class="growthChart">
                            </div>
                        </div> -->
                        <div class="right_2">
                            <div class="box">
                                <div class="right_22">
                                    <div class="apple">
                                        <!-- <span class="card"></span> -->
                                        <span class="subtitle_txt">监管产品分布<img style="margin-left:0.36rem"
                                                src="../../assets/hhr_right.png" alt="" /></span>
                                        <div class="tab_box1">
                                            <div class="tab_item" :class="{ active: regulatoryProductStatus === '进行中' }"
                                                @click="regulatoryProducts('进行中')">
                                                进行中
                                            </div>
                                            <div class="tab_item" :class="{ active: regulatoryProductStatus === '全部' }"
                                                @click="regulatoryProducts('全部')">全部
                                            </div>
                                        </div>
                                    </div>
                                    <div id="flowChart" class="flowChart"></div>
                                </div>
                                <!-- <div id="flowChart" class="flowChart" style=""></div> -->
                                <div class="right_33">
                                    <div class="apple">
                                        <!-- <span class="card"></span> -->
                                        <span class="subtitle_txt">资金使用流向分布<img style="margin-left:0.36rem"
                                                src="../../assets/hhr_right.png" alt="" /></span>
                                    </div>
                                    <div id="productsChart" class="productsChart" style="">
                                        <!-- <div id="container" class="productsChart"> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="b_l left">
                        <div class="title_data">
                            <span class="shadow shadow_">监管增长趋势<img style="margin-left:0.36rem"
                                    src="../../assets/hhr_right.png" alt="" /></span>
                        </div>
                        <div id="growthChart" style="" class="growthChart">
                        </div>
                    </div>
                    <div class="b_l right">
                        <div class="title_data">
                            <span class="shadow shadow_">银行累放贷款排行<img style="margin-left:0.36rem"
                                    src="../../assets/hhr_right.png" alt="" /></span>
                            <div class="search" style="padding-right:.15rem">
                                <el-select @change="tableList" class="select" v-model="userType" placeholder="默认排序"
                                    style="margin-right: 0.13rem;font-size:0.13rem">
                                    <el-option v-for="item in userTypeList" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-select class="select" v-model="time" placeholder="2023"
                                    style="margin-right: 0.13rem;font-size:0.13rem">
                                    <el-option v-for="item in times" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <!-- <div class="total_tabs">
                            <el-tabs v-model="activeName_2" @tab-click="handleClick_2">
                                <el-tab-pane label="活体监管" name="first"></el-tab-pane>
                                <el-tab-pane label="仓单监管" name="second"></el-tab-pane>
                                <el-tab-pane label="无货仓单监管" name="third"></el-tab-pane>
                                <el-tab-pane label="资金流向监管" name="fourth"></el-tab-pane>
                            </el-tabs>
                        </div>
                        <span class="show"
                            v-if="activeName_2 === 'second' || activeName_2 === 'third' || activeName_2 === 'fourth'">暂无预警</span>
                        <div class="table">
                            <dv-scroll-board v-if="activeName_2 === 'first'" :config="config1"
                                style="width:12.3rem;height:3rem;" />
                        </div> -->
                        <dv-scroll-board v-if="activeName_2 === 'first'" @mouseover='mouseover' :config="config1"
                            style="width:100%;height:3.75rem;padding:0 .25rem;padding-bottom: .2rem;" />
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
            </div>
        </div>
    </Main>
</template>
<script>
import Main from "@/components/main.vue";
import Header from "@/components/headerXn.vue";
export default {
    data() {
        return {
            // 金融监管地域分布
            financialSupervisionDis: {},
            financialSupervisionDis_1: {},
            financialSupervisionDis_2: {},
            // 监管预警
            superviseWarning: [],
            headerInfo: {},
            financialServiceStatus: '全部',
            regulatoryProductStatus: '全部',
            activeName_1: 'first',
            activeName_2: 'first',
            userInfo: {},
            region: {},
            // 监管产品分布
            flowData: [],
            flowData_1: [],
            flowData_2: [],
            // b: '',
            // c: ''
            totalMap: {},//地图进行中全部数据
            childMap: [],
            cityName: '',//保存下钻省市名称
            // a: {}
            chart: null,
            isShowMap: true,
            config: {},
            config1: {},
            config2: {},
            config3: {},
            num1: 0,
            num2: 0,
            goBackShow: false,//上一层
            userType: '0',
            userTypeList: [
                { value: '0', label: '默认排序' },
                { value: '1', label: '按累放贷款总额从高到低' },
                { value: '2', label: '按活体监管金额从高到低' },
                { value: '3', label: '按仓单监管金额从高到低' },
                { value: '4', label: '按无货仓单监管金额从高到低' },
                { value: '5', label: '按资金流向监管金额从高到低' },
            ],
            time: '2025',
            times: [
                { value: '0', label: '2026' },
                { value: '1', label: '2025' },
                { value: '2', label: '2024' },
                { value: '3', label: '2023' },
                { value: '4', label: '2022' },
                { value: '5', label: '2021' },
                { value: '6', label: '2020' },
            ],
            headDate: '',//判断是否为正蓝旗登录

            mapDistance:90, //地图缩放距离
            mapDistance2:110 //子地图缩放距离
        }
    },
    components: {
        Main,
        Header,
        // XChart
    },
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))

    },
    mounted() {
        this.tableList()
        this.getData()
    },
    methods: {
        // 返回上一层
        goBack() {
            this.goBackShow = false
            // this.$router.go(0)
            this.isShowMap = false
            this.financialServiceStatus = '全部',
                this.regulatoryProductStatus = '全部',
                this.tableList()
            this.getData()
        },
        // 进行中全部切换
        async financialService(status) {
            this.financialServiceStatus = status
            if (status === "全部") {
                if (this.goBackShow) {
                    this.totalMap['全部'].areaDis.filter(item => {
                        if (item.city == this.cityName) {
                            this.financialSupervisionDis = item
                            this.childMap = item.childMap
                        }
                    })
                } else {
                    this.childMap = this.totalMap['全部'].areaDis
                    this.financialSupervisionDis = this.financialSupervisionDis_2
                }
                if (this.chart != null && this.chart != "" && this.chart != undefined) {
                    this.isShowMap = false
                    this.chart.dispose()
                }
                this.$nextTick(() => {
                    this.isShowMap = true
                    setTimeout(() => {
                        if (this.region.features != undefined && this.region.features[0].properties.country == '正蓝旗') {
                            this.draws(this.region, this.childMap)
                        } else {
                            this.goBackShow ? (this.draw(this.region, this.childMap)) : (this.draw(this.region, this.childMap))
                        }
                    }, 100)
                })
            }
            if (status === "进行中") {
                if (this.goBackShow) {
                    this.totalMap['进行中'].areaDis.filter(item => {
                        if (item.city == this.cityName) {
                            this.financialSupervisionDis = item
                            this.childMap = item.childMap
                        }
                    })
                } else {
                    this.childMap = this.totalMap['进行中'].areaDis
                    this.financialSupervisionDis = this.financialSupervisionDis_1
                }
                if (this.chart != null && this.chart != "" && this.chart != undefined) {
                    this.isShowMap = false
                    this.chart.dispose()
                }
                this.$nextTick(() => {
                    this.isShowMap = true
                    setTimeout(() => {
                        if (this.region.features != undefined && this.region.features[0].properties.country == '正蓝旗') {
                            this.draws(this.region, this.childMap)
                        } else {
                            this.goBackShow ? (this.draw(this.region, this.childMap)) : (this.draw(this.region, this.childMap))
                        }
                    }, 100)
                })
            }
            if (this.goBackShow) {
                this.xiazuanData()
            } else {
                this.config2 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 32,//字体大小
                        fill: '#FFE11D'//字体颜色
                    },
                    textAlign: 'left'
                }
                this.config3 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 32,//字体大小
                        fill: '#FFE11D'//字体颜色
                    },
                    textAlign: 'left'
                }
                setTimeout(() => {
                    console.log(this.financialSupervisionDis.totalMoney);
                    this.config2 = {
                        number: [this.financialSupervisionDis.supervisionTotalCount],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 32,//字体大小
                            fill: '#FFE11D'//字体颜色
                        },
                        textAlign: 'left'
                    },
                        this.config3 = {
                            number: [this.financialSupervisionDis.totalMoney],
                            toFixed: 2,
                            style: {
                                //这里可以修改默认样式
                                fontSize: 32,//字体大小
                                fill: '#FFE11D'//字体颜色
                            },
                            textAlign: 'left'
                        }
                }, 0)
            }

        },
        xiazuanData() {
            this.config2 = {
                number: [0],
                style: {
                    //这里可以修改默认样式
                    fontSize: 32,//字体大小
                    fill: '#FFE11D'//字体颜色
                },
                textAlign: 'left'
            }
            this.config3 = {
                number: [0],
                style: {
                    //这里可以修改默认样式
                    fontSize: 32,//字体大小
                    fill: '#FFE11D'//字体颜色
                },
                textAlign: 'left'
            }
            setTimeout(() => {
                this.config2 = {
                    number: [this.financialSupervisionDis.account],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 32,//字体大小
                        fill: '#FFE11D'//字体颜色
                    },
                    textAlign: 'left'
                },
                    this.config3 = {
                        number: [this.financialSupervisionDis.money],
                        toFixed: 2,
                        style: {
                            //这里可以修改默认样式
                            fontSize: 32,//字体大小
                            fill: '#FFE11D'//字体颜色
                        },
                        textAlign: 'left'
                    }
            }, 0)
        },
        regulatoryProducts(status) {
            this.regulatoryProductStatus = status
            if (this.headDate == '/nmzlqlogin') {
                this.flowData = [
                    { value: 1, name: '仓单监管' },
                    { value: 304, name: '活体监管' },
                ]
                this.flowChart()
                return
            }
            if (status === "全部") {
                this.flowData = this.flowData_2
                this.flowChart()
            }
            if (status === "进行中") {
                this.flowData = this.flowData_1
                this.flowChart()
            }
        },

        // 活畜屠宰折线柱状图
        growthChart(data) {
            // var a=document.ge
            console.log(data);
            var myChart = this.$echarts.init(document.getElementById('growthChart'));
            var option = {
                legend: {
                    top: '3%',
                    // // left: '3%',
                    right: '15%',
                    // bottom: '60%',
                    // show: true,
                    itemWidth: 12,
                    itemHeight: 12,
                    data: [
                        {
                            name: data[0].title,
                            textStyle: {
                                color: '#0EDAE2'
                            },
                        },
                        {
                            name: data[1].title,
                            textStyle: {
                                color: '#00ACFC'
                            },
                            // bottom: 10
                        }
                    ]
                },
                grid: {
                    top: '15%',
                    bottom: '15%',
                    // height: "48%",
                    // containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    show: true,
                    axisLine: {
                        lineStyle: {
                            color: '#04426A',//x轴线条颜色宽度
                            width: 1
                        }
                    },
                    axisLabel: { color: '#FFFFFF' },//x轴刻度文字颜色
                    scale: false,
                    axisTick: { show: false },
                    data: data[0].label

                },
                yAxis: [{
                    type: 'value',
                    name: data[0].title,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF'
                        }
                    },
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    offset: 10,
                    axisTick: { show: false },
                },
                {
                    type: 'value',
                    show: true,
                    name: data[1].title,
                    axisLine: {
                        lineStyle: {
                            color: '#FFFFFF'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#0c1d55'
                        }
                    },
                    offset: 10,
                    // splitNumber: 4,
                    axisTick: { show: false },
                }
                ],
                series: [
                    {
                        name: data[1].title,
                        data: data[1].value,
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: 5,
                        yAxisIndex: 1,
                        itemStyle: {
                            color: '#00ACFC'
                        }
                    },
                    {
                        name: data[0].title,
                        data: data[0].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 10,
                        itemStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#0BE5E1',
                                },
                                {
                                    offset: 0,
                                    color: '#06FDF5',
                                },
                            ]),
                        },
                        backgroundStyle: {
                            color: 'rgba(44, 118, 254, 0.2)'
                        },

                        // tooltip: {
                        //     trigger: 'item'
                        // },
                    }
                ],
                tooltip: {//鼠标悬浮提示数据
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    formatter: function (params) {
                        // console.log(params, 2)
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                            }</p><br/>
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">监管笔数(笔)： ${params[0].value || 0} </span>
                        </p><br/> 
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">监管金额(万)： ${params[1].value || 0} </span>
                         </p>`;
                        // return params.name
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                }
            };
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        productsChart(data) {
            var myChart = this.$echarts.init(document.getElementById('productsChart'));
            var option = {
                color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                grid: {
                    top: '20%',
                    left: '10%',
                    // height: '60px',
                    // height: "100%",
                },
                legend: {
                    icon: "circle",
                    bottom: "0%",
                    left: "center",
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 20,
                    padding: [10, 0, 0, 0],
                    textStyle: { color: '#00E0DB' },
                },
                tooltip: {
                    trigger: 'item',
                    padding: 5,
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 2)
                        return `
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params.data.name + `(万)`}： ${params.data.value || 0} </span>
                        </p><br/> 
                         `;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            // formatter: ' {b} {d}% \n\n',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '%\n\n'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '%\n\n'
                                } else {
                                    return params.name + params.percent + '%\n\n'
                                }
                            },
                            padding: [0, -80],
                            alignTo: 'labelLine'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                // fontSize: '40',
                                // fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                            length: 5,
                            length2: 100,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: [
                            { value: data[0].value, name: data[0].label },
                            { value: data[1].value, name: data[1].label },
                            { value: data[2].value, name: data[2].label },
                            { value: data[3].value, name: data[3].label },
                        ]
                    }
                ]
            };
            myChart.clear()
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        flowChart() {
            var myChart = this.$echarts.init(document.getElementById('flowChart'));
            var option = {
                color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                legend: {
                    icon: "circle",
                    bottom: "0%",
                    left: "center",
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 5,
                    padding: [10, 0, 0, 0],
                    textStyle: { color: '#00E0DB' },
                },
                grid: {
                    top: '20%',
                    left: '10%',
                    // height: '60px',
                },
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    padding: 5,
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 2)
                        return `
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params.data.name + `(笔)`}： ${params.data.value || 0} </span>
                        </p><br/> 
                         `;
                        // <p>
                        //     <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管金额(万)： ${params.data.money || 0} </span>
                        // </p>
                        // return params.name
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            // formatter: ' {b} {d}% \n\n',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '%\n\n'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '%\n\n'
                                } else {
                                    return params.name + params.percent + '%\n\n'
                                }
                            },
                            padding: [0, -80],
                            alignTo: 'labelLine'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                // fontSize: '40',
                                // fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                            length: 5,
                            length2: 80,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: this.flowData
                    }
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        tableList() {
            this.$http({
                url: 'screenapp-service/baseBigScreen/list/bankLoanRank',
                //请求方式
                method: 'post',
                Header: { version: 'yaoyuan' },
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    parentId: "0",
                    menuMark: "3",
                    areaName: '',
                    year: '2023',
                    state: this.financialServiceStatus == '进行中' ? 0 : 1,
                    orderRule: this.userType
                },
            }).then(res => {
                // console.log(res);
                const data = res.data;
                if (res.data.code === 200) {
                    data.result.forEach((item) => {
                        for (var key in item) {
                            if (Number(item[key]) == 0.0) {
                                item[key] = '—'
                            } else if (key !== 'bankName') {
                                if (item[key] < 9999) {
                                    item[key] = item[key] + '万'
                                } else {
                                    var num = 10000
                                    var i = Math.floor(Math.log(item[key]) / Math.log(num))
                                    var sizes = ((item[key] / Math.pow(num, i))).toFixed(1)
                                    item[key] = sizes + '亿'
                                }
                                // item[key] = `${item[key]}${Number(item[key]) > 9999 ? '亿' : '万'}`
                            }
                        }
                    })
                    this.List = []
                    data.result.forEach((item, i) => {
                        this.List.push([i + 1, item.bankName, item.loanAmount, item.huoTiJianGuan, item.cangDanJianGuan,
                        item.wuHuoCangDanJianGuan, item.ziJinLiuXiang])
                    })

                } else {
                    this.List = []
                }
                this.config1 = {
                    header: ['排行', '银行名称', '累放贷款', '活体监管', '仓单监管', '无货仓单监管', '资金流向监管'],
                    data: this.List,
                    align: ['center', 'left', 'right', 'right', 'right', 'right', 'right'],
                    columnWidth: [80, 500, 140, 140, 140, 140, 140],
                    headerHeight: 40,
                    rowNum: 6,
                    waitTime: 2000
                }
                //    setInterval(()=>{
                //     this.$nextTick(() => {
                //         var divs = document.querySelectorAll('.b_l .row-item')
                //         divs = [...divs]
                //         divs.forEach(item => {
                //             item.childNodes.forEach(it => {
                //                 if (it.clientWidth < it.scrollWidth) {
                //                     it.style.lineHeight = 'normal'
                //                     it.style.whiteSpace='normal'
                //                 }
                //             })
                //         })
                //     })
                //    },2000)
            })
        },
        // 银行贷款排行鼠标移入全部显示
        mouseover() {
            var divs = [...document.querySelectorAll('.b_l .row-item')]
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        getData() {
            // console.log(this.userInfo.dept.deptId);
            this.$http({
                // url: 'screenapp-service/baseBigScreen/select',
                url: 'screenapp-service/baseBigScreen/select/financialService',
                //请求方式
                method: 'post',
                Header: { version: 'yaoyuan' },
                //传递的参数
                data: {
                    screenId: 3,
                    deptId: this.userInfo.dept.deptId,
                    parentId: "0",
                    menuMark: "3"
                },
            }).then(res => {
                // console.log(res);
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    console.log(screenData)
                    if(screenData.mapDistance){
                        this.mapDistance = Number(screenData.mapDistance);
                    }
                    this.headerInfo = {
                        // isShow: true,
                        name: data.result.screenName
                    }
                    window.localStorage.setItem('screenName', data.result.screenName)
                    this.financialSupervisionDis_1 = screenData.financialSupervisionDis['进行中']
                    this.financialSupervisionDis_2 = screenData.financialSupervisionDis['全部']
                    this.financialSupervisionDis = this.financialSupervisionDis_2
                    if (this.headDate == '/nmzlqlogin') {
                        this.financialSupervisionDis.supervisionTotalCount = 305
                        this.financialSupervisionDis.totalMoney = 8900
                    }
                    this.config2 = {
                        number: [0],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 36,//字体大小
                            fill: '#FFE11D'//字体颜色
                        },
                        textAlign: 'left'
                    }
                    this.config3 = {
                        number: [0],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 36,//字体大小
                            fill: '#FFE11D'//字体颜色
                        },
                        textAlign: 'left'
                    }
                    setTimeout(() => {
                        console.log(this.financialSupervisionDis.totalMoney);
                        this.config2 = {
                            number: [this.financialSupervisionDis.supervisionTotalCount],
                            style: {
                                //这里可以修改默认样式
                                fontSize: 36,//字体大小
                                fill: '#FFE11D'//字体颜色
                            },
                            textAlign: 'left'
                        },
                            this.config3 = {
                                number: [this.financialSupervisionDis.totalMoney],
                                toFixed: 2,
                                style: {
                                    //这里可以修改默认样式
                                    fontSize: 36,//字体大小
                                    fill: '#FFE11D'//字体颜色
                                },
                                textAlign: 'left'
                            }
                    }, 0)

                    this.flowData = [
                        { value: screenData.productDis[1].仓单监管, name: '仓单监管' },
                        { value: screenData.productDis[1].资金流向监管, name: '资金流向监管' },
                        { value: screenData.productDis[1].无货仓单监管, name: '无货仓单监管' },
                        { value: screenData.productDis[1].活体监管, name: '活体监管' },
                    ]
                    this.flowData_1 = [
                        { value: screenData.productDis[0].仓单监管, name: '仓单监管' },
                        { value: screenData.productDis[0].资金流向监管, name: '资金流向监管' },
                        { value: screenData.productDis[0].无货仓单监管, name: '无货仓单监管' },
                        { value: screenData.productDis[0].活体监管, name: '活体监管' },
                    ]
                    this.flowData_2 = this.flowData
                    this.totalMap = screenData.financialSupervisionDis
                    this.childMap = screenData.financialSupervisionDis['全部'].areaDis
                    this.childMap.forEach(item => {
                        item.name = item.city
                    })
                    this.growthChart(screenData.superviseIncreaseTrend)
                    // this.myChart()
                    if (this.headDate == '/nmzlqlogin') {
                        this.flowData = [
                            { value: 1, name: '仓单监管' },
                            { value: 304, name: '活体监管' },
                        ]
                    }
                    this.flowChart()
                    if (this.headDate == '/nmzlqlogin') {
                        screenData.capitalFlow.forEach((item) => {
                            if (item.label == "活畜交易") {
                                item.value = 96
                            }
                            if (item.label == "屠宰收购") {
                                item.value = 0
                            }
                            if (item.label == "饲料") {
                                item.value = 180
                            } if (item.label == "饲草") {
                                item.value = 0
                            }
                        })
                    }
                    this.productsChart(screenData.capitalFlow)
                    this.isShowMap = true
                    this.getMap()
                } else {
                    this.$message.error(data);
                }
            })
        },
        // changeNum(number) {
        //     var count = 0,
        //         // initial = 0,
        //         step = number / 100;
        //     var timer = setInterval(() => {
        //         count += step;
        //         this.financialSupervisionDis.supervisionTotalCount = count
        //         if (count >= number) {
        //             clearInterval(timer);
        //             count = number;
        //             this.financialSupervisionDis.supervisionTotalCount = count
        //         }
        //     }, 30)

        // },
        // float(arg1, arg2) {
        //     var r1, r2, m;
        //     try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        //     try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        //     m = Math.pow(10, Math.max(r1, r2))
        //     this.b = (arg1 * m + arg2 * m) / m
        // },
        // getNumber(data) {
        //     this.b = 0
        //     this.NUM(data)
        // },
        // NUM(data) {
        //     var num = data.supervisionTotalCount / 10
        //     var timer = setInterval(() => {
        //         this.float(this.b, num)
        //         if (this.b == data.supervisionTotalCount) {
        //             clearInterval(timer)
        //             return
        //         }
        //     }, 1)
        // },
        // float_1(arg1, arg2) {
        //     var r1, r2, m;
        //     try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        //     try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        //     m = Math.pow(10, Math.max(r1, r2))
        //     this.c = (arg1 * m + arg2 * m) / m
        // },
        // getNumber_1(data) {
        //     this.c = 0
        //     this.NUM_1(data)
        // },
        // NUM_1(data) {
        //     // var num = data.totalMoney / 10
        //     var timer = setInterval(() => {
        //         this.float_1(this.c, 0.1)
        //         // this.c = this.c + 0.1
        //         if (this.c == data.totalMoney) {
        //             clearInterval(timer)
        //             return
        //         }
        //     }, 1)
        // },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                if (res.data.code === 200) {
                    this.region = res.data.result.json;
                    if (this.region.features[0].properties.country == '正蓝旗') {
                        this.draws(this.region, this.childMap)
                    } else {
                        this.draw(this.region, this.childMap)//默认显示存栏地图数据
                    }
                }
            })
        },
        // draw(geoJson, data) {
        //     console.log(data, 'jaja');
        //     // console.log(geoJson, 234);
        //     // console.log(data, 123);
        //     // 基于准备好的dom，初始化echarts实例
        //     var chart = this.$echarts.init(document.getElementById("mapMain"));
        //     this.mapMainChart = chart
        //     geoJson.features.forEach((item) => {
        //         item['properties']['cp'] = item.properties.center
        //     })
        //     // bayannaoer
        //     this.$echarts.registerMap("bayannaoer", geoJson);
        //     // 隐藏动画加载效果。
        //     chart.hideLoading();
        //     var option = {
        //         grid: {
        //             top: '30%',
        //             height: "400px",
        //             // containLabel: true,
        //         },
        //         tooltip: {
        //             // 提示框
        //             trigger: "item",
        //             padding: 5,
        //             // backgroundColor: 'rgba(11, 15, 56, 1)',
        //             // borderColor: 'rgba(18, 36, 132, 1)',
        //             // borderWidth: 2,
        //             // textStyle: {
        //             //     color: '#fff',
        //             // },
        //             backgroundColor: 'rgba(255,255,255,0.8)',
        //             borderColor: '#292929',
        //             borderWidth: 1,
        //             textStyle: {
        //                 color: '#050F37',
        //             },
        //             extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
        //             formatter: function (params) {
        //                 // console.log(params, 2)
        //                 // return `<p>
        //                 //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
        //                 //     }： ${params.data.account || 0} </span>

        //                 //       </p>`;
        //                 return `
        //                 <p style="font-size: 14px; font-weight: normal;">${params.name
        //                     }</p><br/>
        //                 <p>
        //                   <span style="font-size: 14px; font-weight: normal;">监管笔数(笔)： ${params.data.account || 0} </span>
        //                 </p><br/> 
        //                  <p>
        //                   <span style="font-size: 14px; font-weight: normal;">监管金额(万)： ${params.data.money || 0} </span>
        //                  </p>`;
        //                 // return params.name
        //             },
        //         },

        //         select: {
        //             itemStyle: {
        //                 areaColor: "#1E88E5",
        //                 borderColor: "#21bde6",
        //                 borderWidth: "1"
        //             },
        //             label: { color: '#fff' },
        //         },
        //         blur: {
        //             itemStyle: {
        //                 areaColor: "#1E88E5",
        //                 borderColor: "#21bde6",
        //                 borderWidth: "1"
        //             }
        //         },
        //         series: [
        //             {
        //                 type: "map", // 系列类型
        //                 name: "map", // 系列名称
        //                 zoom: 1,
        //                 // roam: true,
        //                 map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
        //                 data: data,
        //                 label: {
        //                     // properties.cp
        //                     // 标签的相关设置
        //                     show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
        //                     // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
        //                     position: 'top',
        //                     // offset: [-10, 5],
        //                     textStyle: {
        //                         // 标签的字体样式
        //                         color: "white", // 地图初始化区域字体颜色
        //                         fontSize: 8, // 字体大小
        //                         opacity: 1, // 字体透明度
        //                         backgroundColor: "rgba(0,23,11,0)", // 字体背景色
        //                     },
        //                     // align: 'center',
        //                     // verticalAlign: 'middle'
        //                     // normal: {
        //                     //     show: true,
        //                     //     color: 'rgba(5, 176, 220, 1)',
        //                     //     fontSize: 1, //此处字体需做兼容适配

        //                     //     align: 'left',
        //                     //     verticalAlign: 'middle',
        //                     //     position: 'inside',
        //                     //     distance: 15,
        //                     // },
        //                     // emphasis: {
        //                     //     show: true,
        //                     //     color: '#ececec'
        //                     // }
        //                 },
        //                 itemStyle: {
        //                     // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
        //                     // color: "rgba(33,80,231,1)", // 地图板块的颜色
        //                     color: '#0f3a67',
        //                     opacity: 1, // 图形的不透明度 [ default: 1 ]
        //                     borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
        //                     borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
        //                     normal: { // 默认地图区域样式
        //                         // areaColor: 'rgba(33,80,231,1)',
        //                         areaColor: "#0f3a67",
        //                         // borderColor: "#4ECEE6",
        //                         borderColor: "#165d7d",
        //                         borderWidth: 1,
        //                         // shadowColor: "#2C99F6",
        //                         // shadowOffsetY: 0,
        //                         // shadowBlur: 25,
        //                     },
        //                 },

        //                 emphasis: {
        //                     // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
        //                     label: {
        //                         // label高亮时的配置
        //                         show: true,
        //                         textStyle: {
        //                             color: "#fff", // 高亮时标签颜色变为 白色
        //                             fontSize: 15, // 高亮时标签字体 变大
        //                         },
        //                         formatter: function (params) {
        //                             // console.log(params)
        //                             return params.name
        //                         }
        //                     },
        //                     itemStyle: {
        //                         "areaColor": "#1E88E5"
        //                     }
        //                 }
        //             },
        //         ],
        //     }
        //     chart.clear();
        //     chart.setOption(option);
        //     // chart.on('click', (ret) => {
        //     //     console.log(ret,'wodianle');
        //     // })
        //     window.addEventListener('resize', () => {
        //         chart.resize()
        //     })
        // },
        // 地图
        draw(geoJson, data) {
            console.log(data, 'dfd');
            this.num2 = 0
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    // item.value = item.account
                    item.value = item.money
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
                this.num2 = Number(arrData[arrData.length - 1])
            }
            this.chart = this.$echarts.init(document.getElementById("mapMain"));
            // geoJson.features.forEach((item) => {
            //     item['properties']['cp'] = item.properties.center
            // })
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                tooltip: {
                    show:false,
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 2)
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        return `
                                    <p style="color:#00E0DB;font-size: 20px;">${params.name
                            }</p><br/>
                                    <p>
                                      <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数(笔)： <span style="color: #00E0DB; font-size: 16px;">${params.data.account || 0}</span> </span>
                                    </p><br/> 
                                     <p>
                                      <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管金额(亿)：<span style="color: #00E0DB; font-size: 16px;"> ${params.data.money || 0}</span> </span>
                                     </p>`;
                        // return params.name
                    },
                },
                grid: {
                    // top: '-5%',
                    // show: true,
                    // height:'700px'
                },
                series: [
                    {
                        type: "map3D", // 系列类型
                        name: "map3D", // 系列名称
                        zoom: 1,
                        // aspectScale: 1.2, //长宽比
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        top: '-1%',
                        left: '-8%',
                        // bottom:'50%',
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 12, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                            // align: 'center',
                            // verticalAlign: 'middle'
                            // normal: {
                            //     show: true,
                            //     color: 'rgba(5, 176, 220, 1)',
                            //     fontSize: 1, //此处字体需做兼容适配

                            //     align: 'left',
                            //     verticalAlign: 'middle',
                            //     position: 'inside',
                            //     distance: 15,
                            // },
                            // emphasis: {
                            //     show: true,
                            //     color: '#ececec'
                            // }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#17478F',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter : function(params) {
                                //     console.log(params)
                                // }
                            },
                            itemStyle: {
                                "color": "#00E0DB"
                            }
                        },
                        groundPlane: {
                            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                            show: false, // 是否显示地面。[ default: false ]
                            color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                        },
                        light: {
                            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                            main: {
                                // 场景主光源的设置，在 globe 组件中就是太阳光。
                                color: "#fff", //主光源的颜色。[ default: #fff ]
                                intensity: 1.2, //主光源的强度。[ default: 1 ]
                                shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                                shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                                alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                                beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                            },
                        },

                        viewControl: {
                            // 用于鼠标的旋转，缩放等视角控制。
                            projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                            autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                            rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                            zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                            panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            orthographicSize: 60,
                            // distance: 200, 
                            distance: this.mapDistance, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                            alpha: 70, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                            beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]  60
                            // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                            // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                            // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                            // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                            // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                            animation: true, // 是否开启动画。[ default: true ]
                            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                            animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                        },
                    },
                ],
                visualMap: {
                    show:false,
                    type: 'continuous',
                    // show: true,
                    min: 0,
                    max: this.num1 ? this.num1 * 4 : 0, //控制根据返回值  控制数量
                    right: 35,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${this.num2}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    inRange: {
                        color: this.num2 ? ['rgba(16,53,95,0.4)', 'rgba(250,219,114,1)', 'rgba(244,165,47,1)',
                            'rgba(242,150,43,1)', 'rgba(247,130,24,1)', 'rgba(249,105,33,1)'] : ['rgba(16,53,95,0.4)']  //显示颜色
                    },
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                    pieces: [{
                        gte: this.num1 * 4,
                        label: `${this.num1 * 4}以上`,
                        // color: "#6b3e35"
                        color: "#f96921",
                        opacity: 1
                    }, {
                        gte: this.num1 * 3,
                        lte: this.num1 * 4,
                        label: `${this.num1 * 3} - ${this.num1 * 4}`,
                        color: "#f78218",
                        opacity: 1
                        // color: "#4a383f"
                    },
                    {
                        gte: this.num1 * 2,
                        lte: this.num1 * 3,
                        label: `${this.num1 * 2}-${this.num1 * 3}`,
                        color: "#f2962b",
                        opacity: 1
                        // color: "#303345"
                    }, {
                        gte: this.num1,
                        lte: this.num1 * 2,
                        label: `${this.num1}-${this.num1 * 2}`,
                        color: '#f4a52f',
                        opacity: 1
                        // color: "#192f4d"
                    }, {
                        gte: 1,
                        lte: this.num1,
                        label: `1-${this.num1}`,
                        // color: "#112e50"
                        color: "#fadb72",
                        opacity: 1
                    }, {
                        gte: 0,
                        lte: 0,
                        // color: "#112e50"
                        color: "#10355F",
                        opacity: .4,
                    }
                    ],
                    // },



                },

            };
            this.chart.clear()
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
            // this.chart.on('click', (params) => {
            //     if (this.goBackShow) return
            //     // if (params.name == '锡林郭勒盟') {
            //     this.region.features.forEach((item) => {
            //         if (item.properties.name == params.name) {
            //             this.childMap.filter(item => {
            //                 if (item.name == params.name) {
            //                     this.cityName = item.city
            //                     this.financialSupervisionDis = item
            //                     this.childMap = item.childMap
            //                 }
            //             })
            //             // this.dataInfo = a[0]
            //             // this.getDataList()
            //             // console.log(item.properties.name);
            //             var adcode = item.properties.adcode
            //             this.$http({
            //                 url: 'screenapp-service/map/child/data',
            //                 //请求方式
            //                 method: 'post',
            //                 //传递的参数
            //                 data: {
            //                     adcode: adcode,
            //                 },
            //             }).then(res => {
            //                 if (res.data.code === 200) {
            //                     // this.region = res.data.result.json;
            //                     // console.log(res.data.result.map, ' res.data.result.json');
            //                     if (this.chart != null && this.chart != "" && this.chart != undefined) {
            //                         this.isShowMap = false
            //                         this.chart.clear()
            //                     }
            //                     this.$nextTick(() => {
            //                         this.isShowMap = true
            //                         this.$nextTick(() => {
            //                             this.goBackShow = true
            //                             this.region = res.data.result.map
            //                             this.draw(this.region, this.childMap)
            //                             this.xiazuanData()
            //                         })
            //                     })

            //                     // this.getData()
            //                 }
            //             })
            //         }
            //     })


            // });
        },
        // 正蓝旗
        draws(geoJson) {
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapMain"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();


            var option = {
                tooltip: {
                    textStyle: {
                        color: '#fff'
                    },
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                    },
                },
                geo: {
                    show: true,
                    // roam: true,
                    type: "map", // 系列类型
                    name: "map", // 系列名称
                    zoom: 1.2,
                    map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    // data: data,
                    // selectedMode: 'multiple',
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 12, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                    },
                    select: {
                        disabled: true,
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        },
                        label: {
                            show: false,
                            color: '#fff',
                            position: 'top'
                        },
                    },
                    blur: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        }
                    },
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 8, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                    },
                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        // color: "rgba(33,80,231,1)", // 地图板块的颜色
                        color: '#0f3a67',
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                        normal: { // 默认地图区域样式
                            // areaColor: 'rgba(33,80,231,1)',
                            areaColor: "#0f3a67",
                            // borderColor: "#4ECEE6",
                            borderColor: "#165d7d",
                            borderWidth: 1,
                            // shadowColor: "#2C99F6",
                            // shadowOffsetY: 0,
                            // shadowBlur: 25,
                        },
                    },
                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: false,
                            textStyle: {
                                color: "#fff", // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            // formatter: function (params) {
                            //   // console.log(params)
                            //   return params.name
                            // }
                        },
                        itemStyle: {
                            "areaColor": "#1E88E5"
                        }
                    },
                },
                series: [
                    {
                        color: ['#1998fb'],
                        // type: 'scatter',
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        effectType: 'ripple',
                        rippleEffect: {
                            color: '#00FFFF',
                            number: 3,
                            scale: 5,
                            brushType: 'stroke'
                        },
                        symbolSize: 5,
                        tooltip: {
                            show: false
                        },
                        data: [
                            {
                                name: '上都镇',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [100, -120],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [130, -150],//点偏移
                            },
                            {
                                name: '上都镇',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [0, 0],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [100, 10],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [80, -10],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [100, -20],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [90, -40],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [30, -10],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [80, -30],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [135, -35],//点偏移
                            },
                            {
                                name: '',
                                value: [115.523490, 42.192830],
                                symbol: `circle`,
                                symbolOffset: [130, -100],//点偏移
                            },
                        ]
                    },

                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        drawsss(geoJson, data) {
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    item.value = item.account
                    // item.value > this.num1 ? (this.num1 = item.value) : (this.num1 = 0)
                    // console.log(this.num1, 'this.num1');
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
                this.num2 = Number(arrData[arrData.length - 1])
            }
            console.log(data, 'jaja');
            // console.log(geoJson, 234);
            // console.log(data, 123);
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapMain"));
            // geoJson.features.forEach((item) => {
            //     item['properties']['cp'] = item.properties.center
            // })
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                grid: {
                    // top: '30%',
                    // height: "400px",
                    // containLabel: true,
                },
                select: {
                    disabled: true,
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    },
                    label: {
                        show: false,
                        color: '#fff',
                        position: 'top'
                    },
                },
                blur: {
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    }
                },
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00E0DB;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                        //         <p>
                        //  <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "养殖户分布" ? '养殖户数量' : '活畜数量'}<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "养殖户分布" ? "家" : '头'}</span> </span>
                        //         </p>
                    },
                },
                series: [
                    {
                        type: "map", // 系列类型
                        name: "map", // 系列名称
                        zoom: 1,
                        // roam: true,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 8, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        }
                    },
                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
    }
}
</script>
<style lang="scss">
.financial {
    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    //下拉
    .el-select {
        width: 1.5rem;
        height: 0.38rem;
        line-height: .38rem;
        background: rgba(0, 223, 218, 0.0588);
        border-radius: 0rem 0rem 0rem 0rem;
        opacity: 1;
        border: 0.01rem solid rgba(0, 223, 218, 0.4);

        .el-input__inner {
            // width: 2.79rem;
            height: 0.38rem;
            line-height: .38rem;
            color: #00E0DB !important;
            font-size: .13rem !important;
        }
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
        //     background: url('../../assets/search\ \(1\).png') no-repeat;
        //    background-position: .1rem,.1rem;
    }

    .el-input--suffix .el-input__inner {
        padding-left: .1rem;
    }

    .header {
        background: rgba(0, 224, 219, 0.08) !important;

    }

    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border: none;
        padding-top: 0;
        padding-bottom: 0;
    }

    .el-table {
        padding-left: .2rem;
        padding-right: .2rem;
        margin-top: .25rem;
    }

    /*最外层透明*/
    .el-table,
    .el-table__expanded-cell {
        background-color: transparent;
    }

    /* 表格内背景颜色 */
    .el-table tr {
        background-color: transparent;
    }

    .el-table th {
        color: #f6f6f7;
        /* 字体颜色 */
        /* font-size: 16px; */
        font-size: 0.18rem;
        background-color: transparent !important;
        /* 背景透明 */
        border: 0;
        height: 30px;
        line-height: 30px;
    }

    .el-table tr,
    .el-table td {
        color: #f6f6f7;
        font-size: 0.18rem;
        background-color: transparent !important;
        /* 背景透明 */
        border: 0;
        height: 30px;
        line-height: 30px;
    }

    .el-table th.el-table__cell>.cell {
        font-size: .18rem !important;
    }

    .el-table::before {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    th .cell {
        text-align: center;
    }

    .el-table__row td:nth-child(1) .el-tooltip {
        text-align: center;
    }

    .el-table__row td:nth-child(2) .el-tooltip {
        padding-left: .5rem !important;
    }

    .el-table__row td:nth-child(3) .el-tooltip {
        padding-left: .9rem !important;
    }

    .el-table__row td:nth-child(4) .el-tooltip {
        padding-left: .8rem !important;
    }

    .el-table__body tr.current-row>td.el-table__cell,
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #FFFFFF;
    }

    ::v-deep .el_tabs {
        width: 500px !important;
    }

    /* 设置滚动条样式 */
    /*表格滚动条和字体颜色*/
    .el-table {
        border-bottom: 0;
        color: hsla(0, 0%, 100%, 0.6);
        // padding-right: 0.0625rem;
    }

    .el-table .cell {
        padding: .125rem;
    }

    .el-table th {
        background: rgba(0, 223, 218, 0.08) !important;
    }

    .el-table tr:nth-child(2n) {
        background: rgba(255, 255, 255, 0.03) !important;
    }

    /* 设置滚动条的样式 */
    ::-webkit-scrollbar {
        width: 5px;
        /*滚动条粗细*/
    }

    /* 滚动槽 */
    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
        border-radius: 10px;
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }

    .el-tabs__active-bar {
        height: 0px;
    }

    .el-tabs__nav-wrap::after {
        height: 0px;
    }

    .el-tabs__nav {
        padding-left: 0.2rem;
    }

    .el-table__header {
        // width: 606px;
        margin: 0;
    }

    ::v-deep .goback {
        display: flex;
        align-items: center;
    }

    .el-tabs__header {
        width: 10rem;
    }

    .el-tabs__nav .el-tabs__item:nth-child(5) {
        padding-right: .2rem !important;
    }

    // DataV
    .header {
        background: rgba(0, 223, 218, 0.08) !important;
    }


    .header-item {
        font-size: .175rem !important;
        opacity: .85;
        color: #00E0DB;
    }



    .rows {
        padding: .1rem 0 .2rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(3) {
            color: #00E0DB;
        }

        div:nth-child(7) {
            span {
                margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .dv-scroll-board .rows .ceil {
        font-size: .15rem !important;
        // display: block;
        // box-sizing: border-box;
        // white-space: normal;
        // word-break: break-all;
        // height: auto;
        // word-wrap:break-word;
        // overflow: hidden;
        // line-height: normal;
    }

    .table {
        margin-top: 0.3rem;
        padding: 0 .2rem;
    }
}
</style>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.22rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        // height: 100%;
        position: relative;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);
        padding: 0.2rem .26rem;
        padding-top: .25rem;
        box-sizing: border-box;

        // background-image: url("../../assets/bg-hhr.png");
        // background-size: 100% 100%;
        video {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
        }

        .top {
            display: flex;
            // padding-top: 0.2rem;

            .left {
                width: 10.54rem;
                // width: 50%;
                height: 7.15rem;
                // background-image: url("../../assets/bg_001.png");
                // background-size: 100% 100%;
                border-top: 0.005rem solid rgba(0, 224, 219, 0.3);
                background: linear-gradient(180deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 30%);
                // padding-left: 0.2rem;
                box-sizing: border-box;

                .map_main {
                    // margin: auto;
                    // width: 12rem;
                    width: 100%;
                    height: 5.15rem;
                    overflow: hidden;
                    margin: auto;
                }
            }

            .right {
                display: flex;
                flex-direction: column;
                width: 12.79rem;
                justify-content: space-between;
                // height: 7.15rem;
                // width: 50%;
                margin-left: 0.2rem;

                .right_1 {
                    height: 3.13rem;
                    border-top: 0.005rem solid rgba(0, 224, 219, 0.3);
                    background: linear-gradient(180deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 30%);
                    box-sizing: border-box;
                    // padding-left: 0.2rem;

                    // .growthChart {
                    //     width: 12.7rem;
                    //     height: 2.6rem;
                    // }
                }
            }

            .right_2 {
                // display: flex;
                // height: 4.01rem;
                // height: 50%;
                // background-image: url("../../assets/bg_009.png");
                // background-size: 100% 100%;
                // border-top: 0.005rem solid rgba(0, 224, 219, 0.3);
                // background: linear-gradient(180deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 30%);
                height: 100%;
                box-sizing: border-box;
                // margin-top: 0.2rem;

                .title_l {
                    width: 9.79rem;
                }

                .box {
                    display: flex;
                    // margin-top: 0.38rem;
                    justify-content: space-around;

                    .right_22 {
                        // position: relative;
                        // bottom: -28px;
                        // left: -25px;
                        border-top: 0.005rem solid rgba(0, 224, 219, 0.3);
                        background: linear-gradient(180deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 30%);

                        height: 7.15rem;
                        // height: 6.5rem;
                        display: flex;
                        flex-direction: column;
                        // width: 5rem;
                        width: 6rem;


                        .flowChart {
                            // width: 400px;
                            // height: 160px;
                            // margin: 0.5rem auto
                            // width: 400px;
                            width: 100%;
                            height: 4rem;
                            // height: 2.5rem;
                            margin-top: .7rem;
                            // margin: 0.8rem auto 0.1rem -84px;
                            // margin: 0.8rem auto 0.1rem -22px;
                        }

                        .apple {
                            display: flex;
                            height: .48rem;
                            // flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                            background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 70%);

                            .tab_box1 {
                                display: flex;
                                margin-right: 0.12rem;

                                .tab_item {
                                    font-size: 0.12rem;
                                    font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                                    font-weight: 400;
                                    color: #7B8A89;
                                    // background: rgba(255, 255, 255, 0.0902);
                                    background: rgba(255, 255, 255, 0.05);
                                    padding: 0.05rem 0.08rem;
                                    box-sizing: border-box;
                                    margin: 0.06rem;
                                    cursor: pointer;
                                    border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                                }

                                .active {
                                    background: rgba(255, 255, 255, 0.1) !important;
                                    color: #00E0DB !important;
                                }
                            }
                        }

                    }

                    .right_33 {
                        background: linear-gradient(180deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 30%);

                        border-top: 0.005rem solid rgba(0, 224, 219, 0.3);

                        // margin: auto;
                        margin-left: .2rem;
                        // width: 5.5rem;
                        flex: 1;
                        height: 7.15rem;
                        // height: 6.5rem;
                        display: flex;
                        -webkit-box-orient: vertical;
                        -webkit-box-direction: normal;
                        -ms-flex-direction: column;
                        flex-direction: column;

                        .apple {
                            display: flex;
                            height: .48rem;
                            justify-content: space-between;
                            align-items: center;
                            background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 70%);
                        }

                        .right_item {
                            display: flex;
                            align-items: center;
                            background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 9%, rgba(0, 223, 218, 0) 70%);

                            .card {
                                display: inline-block;
                                width: 0.11rem;
                                height: 0.2rem;
                                background: #00E0DB;
                                opacity: 1;
                                margin-left: .25rem;
                            }

                            .money {
                                width: 3.45rem;
                                height: 0.38rem;
                                font-size: 0.23rem;
                                line-height: 0.38rem;
                                padding-left: 0.15rem;
                                color: #00E0DB;
                                // background-image: url("../../assets/title_bg_001.png");
                                // background-size: 100% 100%;
                            }
                        }

                        .productsChart {
                            width: 100%;
                            height: 4rem;
                            // height: 2.5rem;
                            margin-top: .7rem;
                            // margin-right: 30px;
                            // margin: 1rem auto 1rem -146px;
                        }
                    }
                }

            }
        }
    }

    ::v-deep .show {
        // display: flex;
        width: 2rem;
        display: block;
        color: #A5C5FF;
        font-size: 0.2rem;
        margin: 1.5rem auto;
    }

    .bottom {
        display: flex;
        margin-top: 0.2rem;
        // padding-bottom: .3rem;

        .left {
            // width: 10.54rem;
            width: 10.54rem;
            // width: 49.2%;
            height: 4.63rem;
            border-bottom: 0.005rem solid rgba(0, 224, 219, 0.3);
            // .table {

            //     // width: 620px;
            //     ::v-deep .el-table__header {
            //         width: 608px !important;
            //     }
            // }
            .growthChart {
                width: 10.54rem;
                height: 3.95rem;
            }

            ::v-deep .el-table__row td:nth-child(5) .el-tooltip {
                padding-left: .5rem !important;
                width: 138px !important;
            }

            ::v-deep .el-table__row td:nth-child(6) .el-tooltip {
                padding-left: .5rem !important;
                width: 140px !important;
            }
        }

        .total_tabs {
            // margin-top: 0.2rem;
            width: 3.45rem;
            height: 0.38rem;
            line-height: 0.38rem;
            font-size: 0.2rem;
            font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
            font-weight: 500;
            // color: #FAFAFA;
            // background-image: url("../../assets/title_bg_001.png");
            // background-size: 100% 100%;
            padding-left: 0.2px;

            ::v-deep .el-tabs__item {
                font-size: 0.2rem;
                // line-height: 30px;
                // line-height: 22px;
                padding-left: .2rem;
                color: #A3D8D6;
            }

            ::v-deep .is-active {
                background: rgba(255, 255, 255, 0.1) !important;
                color: #00E0DB;
            }

        }

        .right {
            // width: 12.79rem;
            width: 12.79rem;
            // width: 50%;
            height: 4.63rem;
            margin-left: 0.2rem;
            border-bottom: 0.005rem solid rgba(0, 224, 219, 0.3);

            ::v-deep .el-table__row td:nth-child(5) .el-tooltip {
                padding-left: .8rem !important;
            }

            ::v-deep .el-table__row td:nth-child(6) .el-tooltip {
                padding-left: .4rem !important;
                width: 138px !important;
            }

            ::v-deep .el-table__row td:nth-child(7) .el-tooltip {
                padding-left: .4rem !important;
            }

            ::v-deep .el-table__row td:nth-child(8) .el-tooltip {
                padding-left: .5rem !important;
            }
        }

        .b_l {
            // background-image: url("../../assets/bg_009.png");
            background: linear-gradient(360deg, rgba(0, 223, 218, 0.1) 19%, rgba(0, 223, 218, 0.001) 88%);
            background-size: 100% 100%;
            // padding-left: 0.2rem;
            box-sizing: border-box;

            // ::v-deep .dv-scroll-board .rows .ceil {
            //     font-size: .15rem !important;
            //     white-space: pre-wrap !important; // 不换行,属性在文本超出显示省略号的时候大家一定用过
            //     overflow: none !important; // 内容超过宽度时，隐藏超出部分的内容
            //     text-overflow:inherit !important; // 当文本溢出时，显示省略标记（...），需要与overflow: hidden一起使用
            //     word-wrap: break-word;
            //     word-break: break-all;
            // }
        }

    }

    .title_data {
        font-size: 0.23rem;
        font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
        font-weight: 500;
        color: #FAFAFA;
        // margin-top: 0.38rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .shadow {
            display: inline-block;
            width: 6.25rem;
            height: 0.48rem;
            line-height: .48rem;
            padding-left: .25rem;
            color: #00E0DB;
            background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 70%);

        }

        .shadow_ {
            margin-bottom: 0.2rem;
        }

        .card {
            display: inline-block;
            width: 0.11rem;
            height: 0.2rem;
            background: #00E0DB;
            opacity: 1;
            margin-left: .25rem;
        }

        .subtitle_txt {
            width: 3.45rem;
            // height: 0.38rem;
            font-size: 0.23rem;
            line-height: 0.38rem;
            padding-left: 0.25rem;
            // background-image: url("../../assets/title_bg_001.png");
            // background-size: 100% 100%;
        }

        .tab_box {
            display: flex;
            margin-right: 0.12rem;
            // margin-top: .1rem;
            font-size: .18rem;

            .tab_item {
                font-size: 0.12rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #7B8A89;
                background: rgba(255, 255, 255, 0.05);
                // color: #FFFFFF;
                // background: rgba(255, 255, 255, 0.0902);
                padding: 0.05rem 0.08rem;
                box-sizing: border-box;
                margin: 0.06rem;
                cursor: pointer;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
            }

            .active {
                background: rgba(255, 255, 255, 0.1) !important;
                color: #00E0DB !important;
            }

            span {
                margin: 0 15px;
                height: 34px;
                font-size: 0.3rem !important;
                font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                font-weight: bold;
                color: #00E0DB;
                line-height: 14px;
            }
        }
    }

    .total_data {
        display: flex;
        margin-top: 0.3rem;
        font-size: 0.23rem;
        font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
        font-weight: 500;
        color: #FAFAFA;
        margin-top: 0.38rem;



        .is-active {
            color: #409EFF;
        }

        .total_data_item {
            display: flex;
            margin-left: 0.2rem;

            img {
                width: 0.68rem;
                height: 0.67rem;
            }

            div {
                display: flex;
                flex-direction: column;
                margin-left: 0.2rem;

                label {
                    font-size: 0.18rem;
                    font-weight: 400;
                    color: #D8DFFE;
                    margin-top: 10px;
                }

                span {
                    font-size: 0.43rem;
                    font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                    font-weight: bold;
                    color: #FFE11D;
                    margin-top: 0.2rem;
                }
            }
        }

        .total_data_item_1 {
            // margin-left: 120px;
        }
    }

    .card {
        display: inline-block;
        width: 0.11rem;
        height: 0.2rem;
        background: #00E0DB;
        opacity: 1;
        margin-left: .25rem;
    }

    .subtitle_txt {
        width: 3.45rem;
        height: 0.38rem;
        line-height: 0.38rem;
        padding-left: 0.25rem;
        // font-size: 0.2rem;
        font-size: 0.23rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #00E0DB;
        // background-image: url("../../assets/title_bg_001.png");
        // background-size: 100% 100%;
    }

    .tab_box {
        display: flex;

        .tab_item {
            font-size: 0.12rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            // color: #FFFFFF;
            // background: rgba(255, 255, 255, 0.0902);
            color: #7B8A89;
            background: rgba(255, 255, 255, 0.05);
            padding: 0.05rem 0.08rem;
            box-sizing: border-box;
            margin: 0.06rem;
            cursor: pointer;
            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
        }

        .active {
            background: rgba(255, 255, 255, 0.1) !important;
            color: #00E0DB !important;
        }
    }

    .m_t_sm {
        margin-top: .2rem;
    }
}
</style>
